// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  preprod: false,
  dateFormat: 'YYYY-M-DTH:m:s.SSSZ',
  webApi: 'http://localhost:8909',
  elasticsearchUrl: 'http://localhost:8910/elastic',
  resourcesInventory: 'http://localhost:8108',

  keycloak: {
    // Url of the Identity Provider
    issuer: 'http://localhost:8095/auth/',

    // Realm
    realm: 'master',

    // The SPA's id.
    // The SPA is registerd with this id at the auth-server
    clientId: 'ops-portal',
  }

};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
